import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChartData } from '../../types';

interface ChartState {
  ticker: string;
  data: ChartData | null;
  loading: boolean;
  error: string | null;
  /** Last ticker selected in the charts grid (for highlighting) */
  selectedTicker: string | null;
  /** Page number in charts grid where the selected ticker is located */
  selectedPage: number | null;
}

const initialState: ChartState = {
  ticker: '',
  data: null,
  loading: false,
  error: null,
  selectedTicker: null,
  selectedPage: null,
};

const chartSlice = createSlice({
  name: 'chart',
  initialState,
  reducers: {
    setChartTicker: (state, action: PayloadAction<string>) => {
      // Clear existing data when switching to a new ticker
      if (state.ticker !== action.payload) {
        state.data = null;
        state.error = null;
        state.loading = false;
      }
      state.ticker = action.payload;
    },
    setChartData: (state, action: PayloadAction<ChartData>) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    setChartLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setChartError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearChart: (state) => {
      state.ticker = '';
      state.data = null;
      state.loading = false;
      state.error = null;
    },
    setSelectedChart: (state, action: PayloadAction<{ ticker: string; page: number }>) => {
      state.selectedTicker = action.payload.ticker;
      state.selectedPage = action.payload.page;
    },
    clearSelectedChart: (state) => {
      state.selectedTicker = null;
      state.selectedPage = null;
    },
  },
});

export const { setChartTicker, setChartData, setChartLoading, setChartError, clearChart, setSelectedChart, clearSelectedChart } = chartSlice.actions;
export default chartSlice.reducer; 